document.addEventListener('DOMContentLoaded', function(){
  appStart();
});

function appStart(){
  menuHamburguer();
  testimonios_swiper();

}

function menuHamburguer(){

  const menu = document.querySelector('.hamburguer-menu svg')
  menu.addEventListener('click', function() {
      const mainMenu = document.querySelector('.nav-bar')
      mainMenu.classList.toggle('show-menu')
  })
}

//**
//

function testimonios_swiper(){
  if(document.querySelector('.mySwiper')){
    const opciones = {
      loop: true,
      spaceBetween: 30,
      autoplay: {
        delay:9000
      },


    }
    new Swiper('.mySwiper', opciones);
  }

}










